import { render } from "./ProfilePopup.vue?vue&type=template&id=1e998ecc"
import script from "./ProfilePopup.vue?vue&type=script&lang=js"
export * from "./ProfilePopup.vue?vue&type=script&lang=js"

import "./ProfilePopup.vue?vue&type=style&index=0&id=1e998ecc&lang=scss"
script.render = render

export default script